import declare from "dojo/_base/declare";
import New from "csi/table/New";
import NewFromBOMForm from "./NewFromBOMFormMixin";

const NewFromBOM = declare(New, {

	bomType: null,
	bomRevType: null,

	/**
     * @override
     * set NewFromBOM form controller
     */
	onCreatePopupDefView: function(defView) {
		defView.classController = NewFromBOMForm;
		defView.classControllerParams = {
			bomType: this.bomType,
			bomRevType: this.bomRevType,
		};
		this.inherited(arguments);
	},
});

export = NewFromBOM;